import orderBy from 'lodash/orderBy';
import uuidTime from 'uuid-time';
import { requestAccessSortKeys, sortType } from '../../constants';

const { EMAIL, WORKSPACE, MANAGER, REASON, DATE, STATUS } = requestAccessSortKeys;

export const defaultRequestAccessSortState = {
  key: DATE,
  type: 'date',
  order: sortType.DESC,
};

/** Match getTime(): UUID v1 timestamps first, then conventional date strings. */
export const parseTimestampForSort = (timeStamp) => {
  if (timeStamp == null || timeStamp === '') {
    return 0;
  }
  try {
    return uuidTime.v1(timeStamp);
  } catch (error) {
    const parsed = Date.parse(timeStamp);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
};

export const getDateField = (request, showStatusColumn) => (
  showStatusColumn ? request.lastModifiedDate : request.createdDate
);

const orderByType = (data, type) => {
  if (data == null || data === '') {
    return type === 'date' ? 0 : '';
  }
  switch (type) {
    case 'date':
      return parseTimestampForSort(data);
    default:
      return String(data).toLowerCase();
  }
};

const getSortValue = (request, key, showStatusColumn) => {
  switch (key) {
    case EMAIL:
      return request.email || '';
    case WORKSPACE:
      return request.workspace || '';
    case MANAGER:
      return request.manager || '';
    case REASON:
      return request.reason || '';
    case DATE:
      return getDateField(request, showStatusColumn);
    case STATUS:
      return request.status || '';
    default:
      return '';
  }
};

export const sortRequestAccessRequests = (requests, sortState, showStatusColumn) => {
  const list = (requests || []).slice();
  if (!sortState?.key) {
    return list;
  }
  return orderBy(
    list,
    [(request) => orderByType(getSortValue(request, sortState.key, showStatusColumn), sortState.type)],
    sortState.order,
  );
};
